export default __webpack_public_path__ + "static/media/step5.5cc152a8.png";